<template>
  <div class="video-item-content" :style="`${imgWidth}`">
    <ve-video :source="source"
            @error="handleError"
            :options="options"
            @endEvent="showHeadImg"
            v-if="datamodel.value && datamodel.value.filelocation" class="ve-video"></ve-video>
  </div>
</template>

<script>

import VeVideo from '@/components/VeVideo/index.vue'

export default {
  uuid: "00000000-0000-0000-0000-000000100006",
  components: {
    VeVideo
  },
  props: [
    'datamodel',
    'inList',
    'imgWidth'
  ],
  data() {
    return {
      options: {
          autoplay: false,
          controlBar: {
            timeDivider: false,
            durationDisplay: false,
            remainingTimeDisplay: false,
            fullscreenToggle: true  //全屏按钮
          }
        }
    }
  },
  computed: {
    source() {
        return this.datamodel.value.filelocation
    }
  },
  methods: {
    handleError () {
    },
    showHeadImg () {
    },
  },
  created() {},
  mounted() {
    console.log("imgWidth_style", this.imgWidth)
  }
}
</script>
<style lang="scss">
.video-item-content {
    height: 200px;
    position: relative;
    display:flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    margin: 16px 0;
    // margin: 0 31px;
    .ve-video {
      // width: 100%;
      flex: 1;
      height: 200px;
      border-radius: 8px;
      object-fit: cover;
      .vjs-control-bar {
        //display: none;
      }
    }
}

</style>
